module.exports = __webpack_public_path__ + "img/no_image.b0ffd5ca.png";